import { forwardRef } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import MentionItem from '../MentionItem';

const MentionsList = forwardRef(
  (
    {
      char,
      itemRenderer,
      mentionActiveIndex,
      mentions,
      onClickMention,
      search,
      getOptionHtmlId,
      ...otherProps
    },
    ref,
  ) => (
    <Wrapper
      {...otherProps}
      as="ul"
      role="listbox"
      aria-label={__('Choose who you want to mention')}
      ref={ref}
    >
      {mentions.map((mention, index) => (
        <MentionItem
          key={mention.id}
          htmlId={getOptionHtmlId(index)}
          active={mentionActiveIndex === index}
          char={char}
          itemRenderer={itemRenderer}
          mention={mention}
          onClick={onClickMention}
          search={search}
        />
      ))}
    </Wrapper>
  ),
);

export default MentionsList;

const Wrapper = styled(Box).attrs(({ theme }) => ({
  display: 'block',
  bg: theme.input.bg,
  pt: 2,
  mt: 1,
}))`
  border-radius: 0 0 4px 4px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
`;
